import React from 'react'
import DestinationPage from "./DestinationsPage.jsx"
import Navber from '../../../Components/Navber.jsx'

function MainLayout() {
  return (
    <div>
        <Navber />
      <DestinationPage />
    </div>
  )
}

export default MainLayout